import { useMutation } from '@tanstack/react-query';
import { request } from '../services/request';


export const useCreateOrganisation = () => {
    return useMutation(async (data: any) => {
        const jsonResponse = await request({
            data,
            method: 'POST',
            endpoint: 'org/create',
        });

       if (!jsonResponse.success) {
   
      throw jsonResponse;
    }

    return jsonResponse.data;
    });
};
